/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * 登場アニメーション。その場で完結するものだけ（位置は動かさない・ADR-0023 C）
 */
export type HotspotEnterAnimation = (typeof HotspotEnterAnimation)[keyof typeof HotspotEnterAnimation]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HotspotEnterAnimation = {
  NONE: 'NONE',
  FADE: 'FADE',
  ZOOM: 'ZOOM',
  POP: 'POP',
} as const
